import usePlanStore from './usePlanStore';

import { shallow } from 'zustand/shallow';

const usePlanFacade = () => {
  const { planInfo, planInfoCurrent, loading, error, fetchPlan } = usePlanStore(
    (state) => ({
      planInfo: state.planInfo,
      planInfoCurrent: state.planInfoCurrent,
      loading: state.loading,
      error: state.error,
      fetchPlan: state.fetchPlan,
    }),
    shallow
  );

  return { planInfo, planInfoCurrent, loading, error, fetchPlan };
};

export default usePlanFacade;
